
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

const UsekList = ({
    usekItems,
    onRenderUsek
}) => {
    let n = -1;
    return (
        <Stack>
            {usekItems.map(item => {
                n = (n+1) % 2;
                return onRenderUsek(item, n);
            })}
        </Stack>
    );
}

export default UsekList;
